import { render, staticRenderFns } from "./StudentData.vue?vue&type=template&id=725a97e0&scoped=true&"
import script from "./StudentData.vue?vue&type=script&lang=js&"
export * from "./StudentData.vue?vue&type=script&lang=js&"
import style0 from "./StudentData.vue?vue&type=style&index=0&id=725a97e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725a97e0",
  null
  
)

export default component.exports